module.exports = __webpack_public_path__ + "static/media/k.846418ed.png";